<i18n>
  {
    "fr": {
      "insurances": "Assurances",
      "description": {
        "1": "L’AISC offre l’assurance à ses bénéficiaires.",
        "2": "Vous trouverez le détail des garanties d’assurance annulation et assistance sur le site de l’AISC."
      }
    },
    "en": {
      "insurances": "Insurances",
      "description": {
        "1": "AISC offers insurance to its beneficiaries.",
        "2": "You will find details of cancellation and assistance insurance cover on the AISC website."
      }
    }
  }
</i18n>

<template>
  <div
    id="order-summary"
    class="my-8 pa-4 py-0"
  >
    <FlightItinerarySummary />

    <FlightLuggageOption />

    <v-card
      flat
      class="my-2"
    >
      <v-card-title>
        <h1 class="text--primary title">
          {{ $t('insurances') }}
        </h1>
      </v-card-title>
      <v-card-text class="ml-4">
        {{ $t('description.1') }}
        {{ $t('description.2') }}
      </v-card-text>
    </v-card>

    <FlightPriceSummary @submit="submit" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import FlightPriceSummary from './FlightPriceSummary/FlightPriceSummary'
import FlightItinerarySummary from './FlightItinerarySummary/FlightItinerarySummary'
import FlightLuggageOption from './FlightLuggageOption/FlightLuggageOption'

export default {
  name: 'FlightOrderSummary',
  components: {
    FlightLuggageOption,
    FlightItinerarySummary,
    FlightPriceSummary
  },
  computed: {
    ...mapState({
      isLoading: state => state.fb.step4Loading
    })
  },
  methods: {
    ...mapActions({
      submit: 'fb/bookingOption'
    })
  }
}
</script>

<style scoped>
  #order-summary {
    width: 70%;
    margin-left: 15%;
  }
</style>
